exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".copy-stage-modal-body .no-stages-message {\n  padding: 0.5rem 2rem;\n}\n.copy-stage-modal-body .well {\n  margin-bottom: 0;\n  padding: 10px;\n}\n.copy-stage-modal-body .well p {\n  margin: 0;\n}\n.copy-stage-modal-body .form-horizontal {\n  margin-bottom: 10px;\n}\n", ""]);

